<template>
	<div>
		<sBox title="Filtrar Clientes">
			<div class="row" slot="body">
				<div class="col-sm-2">
					<span>Código</span>
					<input
						v-model="filter.cod"
						placeholder="999"
						@input="fxFilter('cod', $event.target.value)"
						type="number"
						class="form-control"
					/>
				</div>
				<div class="col-md-5">
					<span>Razão social</span>
					<input
						v-model="filter.razao_social"
						@input="fxFilter('razao_social', $event.target.value)"
						type="text"
						class="form-control"
						placeholder="RAZÃO SOCIAL"
					/>
				</div>
				<div class="col-sm-3">
					<span>CNPJ</span>
					<input
						v-mask="'##.###.###/####-##'"
						placeholder="99.999.999/9999-99"
						v-model="filter.cnpj"
						@input="fxFilter('cnpj', $event.target.value)"
						type="text"
						class="form-control"
					/>
				</div>
				<div class="col-sm-2">
					<span>Tipo de contrato</span>
					<select
						disabled
						@input="
							fxFilter('tipo_de_contrato', $event.target.value)
						"
						class="form-control"
					>
						<option value="">Todos</option>
						<option value="avulso">Avulso</option>
						<option value="12MESES">12 Meses</option>
					</select>
				</div>
			</div>
		</sBox>
		<!-- :tabs='user_data.types_of_customers'
			@input='val => fxFilter("tipo_de_cliente", val)'
			v-model='filter.tipo_cliente' type='tabs' -->
		<sBox title="Grid de clientes">
			<div slot="tools">
				<aBtn
					action="private-save-customers"
					@click="$refs.modal.open()"
					text="CLientes"
					icon="plus"
					size="sm"
					type="success"
				/>
			</div>
			<div slot="body">
				<sTable
					ref="tab"
					actionRead="private-read-customers"
					actionDelete="private-delete-customers"
					:labels="labels"
					:actions="['delete', 'edit']"
					:functions="functions"
					block
					@edit="(data) => $refs.modal.open(data)"
				/>
			</div>
		</sBox>
		<modal ref="modal" @update="$refs.tab.updateTable()" />
	</div>
</template>
<script>
	// import WBS from 'js/http'
	import sTable from 'table';
	import sBox from 'box';
	import aBtn from 'btn';
	import modal from './modal.vue';

	import pad from 'js/pad';
	import { mapState } from 'vuex';

	export default {
		name: 'AppCadastroClientes',
		components: { sTable, sBox, modal, aBtn }, //
		data() {
			return {
				filter: {
					cod: '',
					razao_social: '',
					cnpj: '',
					tipo_de_contrato: '',
					tipo_cliente: '',
				},
				labels: [
					{ data: 'cod', label: 'Cod' },
					{ data: 'regiao', label: 'Região' },
					{ data: 'tipo_de_contrato', label: 'Tipo' },
					{
						data: 'razao_social',
						label: 'Empresa',
						css: { 'max-width': '475px' },
					},
					{ data: 'cnpj', label: 'CNPJ' },
				],
				functions: [
					{
						cod: 'cod',
						fx: (val) => {
							return pad(val, 5);
						},
					},
					{
						cod: 'regiao',
						fx: (val) => {
							return `<span class='label label-success'><i class='fa fa-map-marker'></i> ${val}</span>`;
						},
					},
					{
						cod: 'tipo_de_contrato',
						fx: (val) => {
							return val.toUpperCase();
						},
					},
				],
			};
		},
		computed: {
			...mapState(['user_data']),
		},
		methods: {
			fxFilter(col, val) {
				let f = [];
				if (this.filter.cod != '') f.push(`cod = ${this.filter.cod}`);
				if (this.filter.razao_social != '')
					f.push(`razao_social like '%${this.filter.razao_social}%'`);
				if (this.filter.cnpj != '')
					f.push(`cnpj like '%${this.filter.cnpj}%'`);

				// if(col == 'tipo_de_contrato') this.filter.tipo_de_contrato = val
				// if(this.filter.tipo_de_contrato != '') f.push( `tipo_de_contrato = '${this.filter.tipo_de_contrato}'` )

				// if(this.filter.tipo_cliente != '') f.push(`tipo_de_cliente = '${this.filter.tipo_cliente}'`)

				f = f.join(' and ');

				// console.log(f)

				if (f != '') this.$refs.tab.setFilter(f);
				else this.$refs.tab.setFilter('');
				this.$refs.tab.updateTable();
			},
		},
		mounted() {
			this.$refs.tab.updateTable();
			// if(typeof this.user_data.types_of_customers == 'object'){
			// 	if(this.user_data.types_of_customers.length > 0){
			// 		// this.filter.tipo_cliente = this.user_data.types_of_customers[0].cod
			// 		// this.$refs.tab.setFilter(`tipo_de_cliente = '${this.filter.tipo_cliente}'`)
			// 	}
			// }
			this.$emit('setHeader', ['Gerenciamento de Clientes', '']);
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/cadastros/customers/index.vue